var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecureLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 602,
    width: 802,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "rotate(-0.37523961067199707 412.63171386716976,295.1167907714852) ",
    id: "svg_33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    transform: "matrix(0.8298247504528445,0,0,0.8298247504528445,-3974.9275137664786,-2994.9641648034235) ",
    id: "svg_5",
    fill: "#e6e6e6",
    ry: 12,
    rx: 158,
    cy: 4228.65564,
    cx: 5048.83221
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    fill: "#2f2e41",
    d: "m183.82592,167.78312c22.81749,-9.70505 51.23705,-3.55603 78.99178,0.71163c0.25827,-5.16815 3.38888,-11.45807 0.10954,-15.06368c-3.98411,-4.38048 -3.61735,-8.98309 -1.21991,-13.61224c6.13065,-11.83745 -2.65287,-24.43315 -11.52152,-34.90633a19.64143,19.64143 0 0 0 -16.39349,-6.88073l-16.42846,1.17346a19.67464,19.67464 0 0 0 -17.47027,14.06233l0,0c-3.92278,5.33508 -6.02234,10.65541 -4.70044,15.94802c-5.8757,4.01537 -6.86289,8.86234 -4.22257,14.32643c2.23887,3.44039 2.21503,6.7893 -0.10186,10.04553a46.37956,46.37956 0 0 0 -6.89593,13.69717l-0.14686,0.49841z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_7",
    fill: "#2f2e41",
    d: "m726.0638,461.99209l-465.04854,0a15.59333,15.59333 0 0 1 -15.59333,-15.59333l0,0q252.87001,-29.38834 496.2352,0l0,0a15.59333,15.59333 0 0 1 -15.59333,15.59333z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_8",
    fill: "#3f3d56",
    d: "m741.65713,447.31601l-496.2352,-0.91726l57.51193,-96.77045l0.27517,-0.45863l0,-213.27108a19.71016,19.71016 0 0 1 19.71181,-19.71181l338.48561,0a19.71016,19.71016 0 0 1 19.71181,19.71181l0,214.73866l60.53889,96.67875z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_9",
    fill: "#fff",
    d: "m322.47139,129.94562a6.42801,6.42801 0 0 0 -6.42079,6.42079l0,194.45815a6.4283,6.4283 0 0 0 6.42079,6.42079l342.13628,0a6.42858,6.42858 0 0 0 6.42079,-6.42079l0,-194.45815a6.4283,6.4283 0 0 0 -6.42079,-6.42079l-342.13628,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_10",
    fill: "#2f2e41",
    d: "m323.90505,362.92851a2.75935,2.75935 0 0 0 -2.50005,1.60161l-17.72121,38.52473a2.75165,2.75165 0 0 0 2.49961,3.90192l372.66772,0a2.75145,2.75145 0 0 0 2.46065,-3.98254l-19.26237,-38.52473a2.73781,2.73781 0 0 0 -2.46065,-1.52099l-335.6837,0z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    transform: "matrix(0.8298247504528445,0,0,0.8298247504528445,-3974.9275137664786,-2994.9641648034235) ",
    id: "svg_11",
    fill: "#fff",
    r: 4.97412,
    cy: 3756.90379,
    cx: 5383.17417
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_12",
    fill: "#2f2e41",
    d: "m455.53344,414.29481a2.75596,2.75596 0 0 0 -2.65681,2.03606l-4.4452,16.5106a2.7515,2.7515 0 0 0 2.65682,3.46747l84.53757,0a2.75113,2.75113 0 0 0 2.59948,-3.652l-5.71493,-16.5106a2.75323,2.75323 0 0 0 -2.60039,-1.85153l-74.37655,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_13",
    fill: "#2f2e41",
    points: "681.1178970336914,345.9594234228134 681.1178970336914,349.6280940771103 302.93372344970703,349.6280940771103 303.2183609008789,349.1699641942978 303.2183609008789,345.9594234228134 681.1178970336914,345.9594234228134 "
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    transform: "matrix(0.8298247504528445,0,0,0.8298247504528445,-3974.9275137664786,-2994.9641648034235) ",
    id: "svg_14",
    fill: "#1083c6",
    r: 77.37524,
    cy: 3766.29935,
    cx: 5598.16678
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_15",
    fill: "#fff",
    d: "m697.17023,158.38057l-53.2008,0a3.67265,3.67265 0 0 1 -3.66902,-3.66903l0,-32.10396a3.67294,3.67294 0 0 1 3.66902,-3.66902l53.2008,0a3.67294,3.67294 0 0 1 3.66902,3.66902l0,32.10394a3.67265,3.67265 0 0 1 -3.66902,3.66905zm-53.20082,-35.77296l0,32.10394l53.20351,0l-0.00269,-32.10396l-53.20082,0.00002z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_16",
    fill: "#fff",
    d: "m687.08043,122.60758l-33.02122,0l0,-14.67609c0,-10.62995 6.94391,-18.34511 16.5106,-18.34511s16.51059,7.71516 16.51059,18.34511l0.00002,14.67609zm-29.35217,-3.66902l25.68315,0l0,-11.00707c0,-8.64097 -5.28049,-14.67608 -12.84154,-14.67608s-12.84158,6.03516 -12.84158,14.67608l-0.00003,11.00707z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    transform: "matrix(0.8298247504528445,0,0,0.8298247504528445,-3974.9275137664786,-2994.9641648034235) ",
    id: "svg_17",
    fill: "#fff",
    r: 4.42139,
    cy: 3775.14223,
    cx: 5598.16678
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_18",
    fill: "#e6e6e6",
    d: "m625.74716,271.28712l-264.41526,0a4.90233,4.90233 0 0 1 -4.89657,-4.89657l0,-65.59017a4.90233,4.90233 0 0 1 4.89657,-4.89656l264.41526,0a4.90233,4.90233 0 0 1 4.89657,4.89656l0,65.59018a4.90233,4.90233 0 0 1 -4.89657,4.89656zm-264.41526,-73.42464a2.94115,2.94115 0 0 0 -2.93794,2.93794l0,65.59014a2.94116,2.94116 0 0 0 2.93794,2.93794l264.41526,0a2.94116,2.94116 0 0 0 2.93794,-2.93794l0,-65.59018a2.94115,2.94115 0 0 0 -2.93794,-2.93794l-264.41526,0.00004z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    transform: "matrix(0.8298247504528445,0,0,0.8298247504528445,-3974.9275137664786,-2994.9641648034235) ",
    id: "svg_19",
    fill: "#e6e6e6",
    r: 24.03638,
    cy: 3887.61958,
    cx: 5275.02242
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_20",
    fill: "#e6e6e6",
    d: "m448.48254,217.78143a3.32434,3.32434 0 1 0 0,6.64868l156.71883,0a3.32434,3.32434 0 0 0 0,-6.64868l-156.71883,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_21",
    fill: "#e6e6e6",
    d: "m448.48254,237.72747a3.32434,3.32434 0 1 0 0,6.64867l67.43654,0a3.32434,3.32434 0 1 0 0,-6.64867l-67.43654,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_22",
    fill: "#ffb8b8",
    d: "m302.28318,239.07224l-48.87925,25.98645l-0.61873,-21.65535c15.95382,-2.66331 31.13228,-7.3003 45.16687,-14.84938l5.11214,-12.63a8.56174,8.56174 0 0 1 14.55216,-2.22217l0,0a8.56174,8.56174 0 0 1 -0.75387,11.67468l-14.57932,13.69577z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_23",
    fill: "#2f2e41",
    d: "m182.85164,389.10842l0,0a9.60421,9.60421 0 0 1 1.21924,-7.76974l10.73736,-16.47847a18.76417,18.76417 0 0 1 24.34291,-6.42224l0,0c-4.51259,7.68125 -3.88353,14.41969 1.55846,20.27565a97.61299,97.61299 0 0 0 -23.18203,15.80395a9.60428,9.60428 0 0 1 -14.67594,-5.40915z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_24",
    fill: "#2f2e41",
    d: "m304.50939,367.56258l0,0a18.42472,18.42472 0 0 1 -15.6595,8.94476l-71.33196,0.5404l-3.09359,-17.943l31.55492,-9.28087l-26.60514,-20.4179l29.07999,-34.02982l52.81835,49.22878a18.42474,18.42474 0 0 1 3.23694,22.95765z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_25",
    fill: "#2f2e41",
    d: "m206.38088,490.27428l-16.70555,0c-14.99916,-102.81339 -30.26689,-205.91426 14.84938,-244.39608l53.21028,8.66214l-6.80597,45.16685l-29.69876,34.02983l-14.84938,156.53726z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_26",
    fill: "#2f2e41",
    d: "m221.06588,513.5646l0,0a9.60423,9.60423 0 0 1 -7.76982,-1.21879l-18.13876,-2.43814a18.76417,18.76417 0 0 1 -6.42367,-24.3425l0,0c7.68152,4.51216 14.41992,3.88268 20.27556,-1.55966c4.13745,8.35416 10.95446,7.84459 17.46496,14.88286a9.60427,9.60427 0 0 1 -5.40827,14.67623z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_27",
    fill: "#ffb8b8",
    d: "m245.97924,177.19982l-30.93622,-7.4247c5.13801,-10.51712 5.56111,-22.21954 3.09359,-34.64855l21.03662,-0.61873c0.65917,15.45582 2.65333,29.89544 6.80601,42.69198z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_28",
    fill: "#1083c6",
    d: "m254.48156,273.16975c-22.52039,15.34602 -38.43265,0.52505 -50.57557,-22.34175c1.68735,-13.99241 -1.04475,-30.73721 -6.10479,-48.93174a33.30719,33.30719 0 0 1 20.33541,-40.16455l0,0l26.60514,11.13708c22.59083,18.41413 27.03735,38.36031 18.56173,59.39753l-8.82193,40.90343z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_29",
    fill: "#ffb8b8",
    d: "m189.67533,192.66792l-24.74898,12.99321l43.92943,25.98642l6.11249,15.07751a7.9968,7.9968 0 0 1 -4.80406,10.5644l0,0a7.9968,7.9968 0 0 1 -10.58988,-7.09037l-0.61813,-10.50813l-55.83376,-18.42515a13.05568,13.05568 0 0 1 -8.19257,-7.97584l0,0a13.05563,13.05563 0 0 1 4.89814,-15.18793l44.89754,-30.80181l4.94978,25.36768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_30",
    fill: "#1083c6",
    d: "m214.4243,195.14282c-10.32187,-4.52346 -19.70779,0.39038 -31.55492,4.33107l-1.85618,-32.79239c11.7637,-6.26989 22.97958,-7.96035 33.41111,-3.09359l-0.00002,31.55491z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    transform: "matrix(0.8298247504528445,0,0,0.8298247504528445,-3974.9275137664786,-2994.9641648034235) ",
    id: "svg_31",
    fill: "#ffb8b8",
    r: 23.802,
    cy: 3767.01663,
    cx: 5063.35717
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_32",
    fill: "#2f2e41",
    d: "m250.40088,128.50732c-19.55578,1.91533 -34.45713,-1.28296 -43.98071,-10.38946l0,-7.33374l42.32106,0l1.65965,17.72321z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureLogin);
export default __webpack_public_path__ + "static/media/secure_login.a7256f18f6f532a7204b7b80215cd9c3.svg";
export { ForwardRef as ReactComponent };